import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["classes", "children", "contained", "windowHeight"];
import React from 'react';
import { Typography, CircularProgress, createStyles, withStyles } from '@material-ui/core';
import { WindowHeightProvider } from '../HeightUtils';
const minSize = 100;
const maxSize = 300;
const innerAdjust = 25;
const baseVwAdjust = 1.35;
const innerVwAdjust = `${baseVwAdjust}vw`;
const zIndex = 1000;
const styles = createStyles(theme => ({
  '@keyframes shine': {
    '0%': {
      backgroundPosition: '-300%'
    },
    '100%': {
      backgroundPosition: '300%'
    }
  },
  '@keyframes circular-rotate-reverse': {
    '0%': {
      transformOrigin: '50% 50%;'
    },
    '100%': {
      transform: 'rotate(-360deg)'
    }
  },
  '@keyframes circular-dash-reverse': {
    '0%': {
      strokeDasharray: '100px, 200px',
      strokeDashoffset: '-125px'
    },
    '50%': {
      strokeDasharray: '100px, 200px',
      strokeDashoffset: '-15px'
    },
    '100%': {
      strokeDasharray: '1px, 200px',
      strokeDashoffset: '0px'
    }
  },
  fixedLoaderRoot: _props => ({
    position: 'fixed',
    display: 'flex',
    margin: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '100%',
    padding: 0,
    zIndex
  }),
  containedLoaderRoot: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex
  },
  loaderText: {
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%)',
    overflow: 'hidden',
    background: 'linear-gradient(90deg, #333, #fff, #333)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '80%',
    animation: '$shine 1.5s linear infinite',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'rgba(255, 255, 255, 0.1)',
    width: `${15 - baseVwAdjust * 3}vw`,
    textAlign: 'center',
    alignItems: 'unset',
    minWidth: 60,
    maxWidth: maxSize,
    height: 'fit-content',
    alignSelf: 'center',
    [theme.breakpoints.only('xs')]: {
      width: 60
    },
    [theme.breakpoints.only('xl')]: {
      width: maxSize
    }
  },
  progressRoot: {
    color: '#75c4e8'
  }
}));

const Message = ({
  classes,
  children
}) => /*#__PURE__*/React.createElement(Typography, {
  variant: "caption",
  classes: {
    root: classes.loaderText
  }
}, children);

const ProgressBody = _ref => {
  let {
    classes,
    children,
    contained,
    windowHeight: _windowHeight
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: contained ? classes.containedLoaderRoot : classes.fixedLoaderRoot
  }), /*#__PURE__*/React.createElement(CircularProgress, {
    classes: {
      root: classes.progressRoot
    }
  }));
};

const DefaultLoader = withStyles(styles)( /*#__PURE__*/React.memo(ProgressBody));
/** @component */

export const Loader = props => /*#__PURE__*/React.createElement(WindowHeightProvider, null, windowHeight => /*#__PURE__*/React.createElement(DefaultLoader, _extends({}, props, {
  windowHeight: windowHeight.clientHeight
})));
export default Loader;